<script>
  import { Navigation, Pagination, A11y } from 'swiper';
  import { Swiper, SwiperSlide } from 'swiper/svelte';
  import {fade} from 'svelte/transition'
  import "carbon-components-svelte/css/g90.css";
  import {Button, Form, TextInput, Select, SelectItem, Checkbox, DatePicker, DatePickerInput} from 'carbon-components-svelte';
  import {Motion, M} from 'svelte-motion'
  import Tailwindcss from '../Tailwind.svelte'
  import {animateScroll} from 'svelte-scrollto-element'
  import { registerUser } from '../auth';
  import states from '../states.js'
  import * as EmailValidator from 'email-validator';
  import {getCountries}  from '../userdata'
  import {itemB} from './animations'
  import {_} from 'svelte-i18n'
  import {sessionData} from '../stores'
  import { onMount } from 'svelte';
  import {fly} from 'svelte/transition'

  import {signInWithGoogle} from '../auth'
  let swiper;
  let anchor
  let anchor_view
  let spinner = false
  export let variants
  export let container

  let trigger = "hidden"
  $: emailValid = EmailValidator.validate($sessionData.signin_user.email)
  $: usernameValid = $sessionData.signin_user.displayName.length >= 5 && $sessionData.signin_user.displayName.length <= 15
  $: completed = $sessionData.signin_user.displayName && $sessionData.signin_user.location && emailValid

  let countryLookup = [
    { "iso": "AT", "country": "Austria " },
    { "iso": "AU", "country": "Australia " },
    { "iso": "BE", "country": "Belgium " },
    { "iso": "BR", "country": "Brazil " },
    { "iso": "CA", "country": "Canada " },
    { "iso": "CZ", "country": "Czech Republic " },
    { "iso": "DK", "country": "Denmark " },
    { "iso": "FI", "country": "Finland " },
    { "iso": "DE", "country": "Germany " },
    { "iso": "GR", "country": "Greece " },
    { "iso": "HU", "country": "Hungary " },
    { "iso": "IE", "country": "Ireland " },
    { "iso": "NL", "country": "Netherlands The " },
    { "iso": "NO", "country": "Norway " },
    { "iso": "PL", "country": "Poland " },
    { "iso": "PT", "country": "Portugal " },
    { "iso": "SK", "country": "Slovakia " },
    { "iso": "ES", "country": "Spain " },
    { "iso": "SE", "country": "Sweden " },
    { "iso": "US", "country": "United States " },
    { "iso": "EE", "country": "Estonia " },
  ];

  animateScroll.setGlobalOptions({ scrollX: true, scrollY: false });

  function onKeyDown(event) {
    if (event.key === 'Enter' && completed ) register()
  }

  function register() {
    if (completed) sessionData.update(s => ({...s , signin_flow: "terms"}));
  }

  onMount(() => {
    setTimeout(() => {
      console.log('$sessionData.geoCountry', $sessionData.geoCountry);
      const text = countryLookup.find(c => c.iso == $sessionData.geoCountry).country
      $sessionData.signin_user.location = text
    }, 800)

    setTimeout(() => { trigger = "show"; }, 3000)
  })

  function scrollIntoView({ target }) {
    if (anchor) {
      anchor.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'center',
      })
    }
  }

  const scroller = () => { animateScroll.scrollTo({element: anchor}); }

</script>
<Tailwindcss/>

<svelte:window on:keydown={onKeyDown} />

<M.div class="flex flex-col gap-y-10 select-none" initial="hidden" variants={container} {trigger} >

  <M.h1 variants={itemB} class="min-w-max text-6xl" >{$_("gameplay.getStarted")}</M.h1>

  <M.div class="w-80 mt-24" {variants}>
    <TextInput class="w-80"
               bind:value={$sessionData.signin_user.displayName}
               placeholder={$_("signUp.username")}
               invalidText={$_("signUp.usernameInvalid")}
               invalid={$sessionData.signin_user.displayName && !usernameValid}
               />
  </M.div>

  <M.div class="w-80" {variants}>
    <TextInput class="w-80"
               bind:value={$sessionData.signin_user.email}
               placeholder={$_("signUp.email")}
               invalidText={$_("signUp.emailInvalid")}
               invalid={$sessionData.signin_user.email && !emailValid}
               />
  </M.div>
  <M.div {variants}>
    {#key $sessionData.signin_user.location}
      <Select class="w-80"
              bind:selected={$sessionData.signin_user.location}
              defaultValue={$sessionData.signin_user.location}
              placeholder="location">

        {#await getCountries()}
          <SelectItem value={$sessionData.signin_user.location}>loading...</SelectItem>

        {:then countries}
          {#each countries as country}
            <SelectItem value={country}>{country}</SelectItem>
          {/each}
        {/await}


    </Select>
  {/key}



  </M.div>

  {#if $sessionData.geoCountry === 'US' && $sessionData.signin_user.location === 'United States '}
    <!--{#if true}-->
      <Select class="w-80" bind:selected={$sessionData.signin_user.state} placeholder="Alabama">
        {#each states as _state}
          <SelectItem value={_state.name}>{_state.name}</SelectItem>
        {/each}
      </Select>
    {/if}



{#if $sessionData.signin_user.displayName && $sessionData.signin_user.location}
  <button in:fly={{y:30}} on:click={register} {variants}>
    <img class:opacity-50={!completed} class="mt-12 self-end w-32" src="arrow-right.svg" alt="arrow-right.svg"/>
  </button>
{/if}
</M.div>

<style>
</style>
